module.exports = __webpack_public_path__ + "img/deal-four.bdeb6a73.png";